import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { DimonaRequest } from './dimona-request.interface';

export const DIMONA_REQUEST_INCLUDES = ['userCompany', 'contract', 'employee', 'employerCompany', 'dimonaStatus'];

export class DimonaRequestService {
   async getDimonaRequests(query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<DimonaRequest>>(`/dimona-requests`, { params: { ...query } });
      return response.data;
   }

   async getDimonaRequest() {
      throw Error('Method not implemented');
   }

   async postDimonaRequest() {
      throw Error('Method not implemented');
   }

   async putDimonaRequest() {
      throw Error('Method not implemented');
   }

   async deleteDimonaRequest() {
      throw Error('Method not implemented');
   }

   async resend(dimonaRequestId: number) {
      return await http.get(`/dimona-requests/${dimonaRequestId}/resend`);
   }
}
